import * as React from 'react';

import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";

import {Dialogs} from "./types";
import {STATUS, STATUS_NAMES} from "../../types/enums";

interface FooterProps {
    onSubmit: (event: React.MouseEvent<HTMLButtonElement>) => void,
    onHide?: () => void
    disabled: boolean
    isLastWrittenReply: boolean
}

const Footer = ({onSubmit, onHide, disabled = false, isLastWrittenReply}: FooterProps) => {
    return (
        <div>
            {!isLastWrittenReply && (
                <Button
                    label='Закрыть'
                    className={'p-button'}
                    onClick={onHide}
                />
            )}
            {isLastWrittenReply && (
                <Button
                    disabled={disabled}
                    label='Отправить'
                    className={'p-button-success'}
                    onClick={onSubmit}
                />
            )}
        </div>
    )
}

interface State extends Record<string, unknown> {
    isOpen: boolean
    resolved: string
}

interface Props extends Dialogs {
    data: any
    onHide: () => void
    onSubmitReply: (resolved) => void
}

export class WrittenReplyDialog extends React.Component<Props, State> {
    state = {
        isOpen: false,
        resolved: undefined,
    }

    handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        this.props.onSubmitReply(!!JSON.parse(this.state.resolved))
    }

    handleInput = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({
            [event.currentTarget.name]: event.currentTarget.value
        })
    }

    render() {
        const {data: {history, status}} = this.props;

        const findReply = history?.filter(_h => _h?.status === STATUS_NAMES?.['WrittenReply']) || null
        const isLastWrittenReply = STATUS?.[status] === 'WrittenReply'

        return (
            <Dialog
                header="Письменный ответ"
                className='custom-dialog'
                visible={this.props.visible}
                onHide={this.props.onHide}
                closable={false}
                draggable={false}
                style={{maxWidth: '700px', width: '100%'}}
                footer={Footer({
                    onSubmit: this.handleSubmit,
                    disabled: !this.state.resolved,
                    onHide: this.props.onHide,
                    isLastWrittenReply
                })}
            >
                <div className="form-group">
                    <div
                        style={isLastWrittenReply ? {
                            padding: '2rem',
                            fontSize: '1.5rem',
                            marginBottom: '4rem',
                            borderRadius: '.5rem',
                            border: '1px solid #e5e5e5'
                        } : null}
                    >
                        {findReply?.[0]?.comment ?? 'Письменный ответ не найден'}
                    </div>
                </div>

                {isLastWrittenReply && (
                    <>
                        <h6 className={'required'}>Пожалуйста сообщите нам, решен-ли ваш вопрос</h6>
                        <div className="form-group" style={{display: 'flex'}}>
                            <label className="order-wrapper" style={{marginRight: '3rem'}}>
                                <input
                                    type="radio"
                                    name={'resolved'}
                                    value={'true'}
                                    onChange={this.handleInput}
                                    checked={this.state?.resolved === 'true'}
                                    style={{marginRight: '0'}}
                                />
                                <div className="reportbox-content-desc">
                                    Решен
                                </div>
                            </label>

                            <label className="order-wrapper">
                                <input
                                    type="radio"
                                    name={'resolved'}
                                    value={'false'}
                                    onChange={this.handleInput}
                                    checked={this.state?.resolved === 'false'}
                                    style={{marginRight: '0'}}
                                />
                                <div className="reportbox-content-desc">
                                    Не решен
                                </div>
                            </label>
                        </div>
                        {this.state.resolved === 'false' && (
                            <div className="form-group">
                                <strong>Просим изменить текст заявки и уточнить повестку, для более конкретного ответа</strong>
                            </div>
                        )}
                    </>
                )}

            </Dialog>
        );
    }
}

